<template>
  <div>
    <title-bar :title-stack="titleStack" />
    <hero-bar>
      Reporting Tracker
      <div slot="right">
        <router-link
          to="/reportingtracker/add"
          style="color: white"
          class="is-small is-info is-action-text"
          v-slot="{ href, navigate }"
        >
          <div>
            <b-button
              v-if="isAdmin()"
              type="is-primary"
              :href="href"
              @click="navigate"
            >
              <span class="add-button-right"
                >+ &nbsp;&nbsp;&nbsp;Add One-Off Report</span
              >
            </b-button>
          </div>
        </router-link>
      </div>
      <template v-if="!isUserExternal">
        <div class="navbar-menu" slot="right">
          <div class="navbar-ends">
            <b-dropdown
              position="is-bottom-left"
              append-to-body
              aria-role="menu"
              trap-focus
            >
              <a
                class="navbar-item navbar-mdi-tune-dropdown"
                slot="trigger"
                role="button"
              >
                <button class="button">
                  <span class="mdi mdi-tune mdi-24px mdi-dark"></span>
                </button>
              </a>

              <b-dropdown-item aria-role="listitem" has-link>
                <router-link
                  :to="{ name: 'reportingTracker.countryOverview' }"
                  class="dropdown-links-column"
                  data-cy="countryOverview"
                >
                  Country Support Overview
                </router-link>
              </b-dropdown-item>
              <b-dropdown-item aria-role="listitem" has-link>
                <router-link
                  :to="{ name: 'reportingTracker.CAMSupportOverview' }"
                  class="dropdown-links-column"
                  data-cy="CAMSupportOverview"
                >
                  Customer Account Manager Support Overview
                </router-link>
              </b-dropdown-item>
              <b-dropdown-item aria-role="listitem" has-link>
                <router-link
                  :to="{ name: 'reportingTracker.messageConfigurator' }"
                  class="dropdown-links-column"
                  data-cy="messageConfigurator"
                >
                  Default Message Configurator
                </router-link>
              </b-dropdown-item>

              <b-dropdown-item aria-role="listitem" has-link>
                <router-link
                  :to="{ name: 'reportingTracker.customerUpdates1' }"
                  class="dropdown-links-column"
                  data-cy="customerUpdate"
                >
                  Customer Updates
                </router-link>
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </div>
      </template>
    </hero-bar>
    <section class="section is-main-section">
      <reporting-tracker-list :checkable="true" />
    </section>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import HeroBar from "@/components/HeroBar";
import TitleBar from "@/components/TitleBar";
import { Permission } from "../../services/Permissions";
import ReportingTrackerList from "@/components/Reportingtracker/ReportingTrackerList";

export default {
  name: "ReportingTracker",
  components: { HeroBar, TitleBar, ReportingTrackerList },
  computed: {
    ...mapGetters([
      "userId",
      "userName",
      "userHasPermission",
      "isUserExternal"
    ]),
    titleStack() {
      return [{ url: "/reportingtracker", name: "Reporting Tracker" }];
    }
  },
  data() {
    return {
      isModalActive: false
    };
  },
  methods: {
    addModal(trashObject) {
      this.trashObject = trashObject;
      this.isModalActive = true;
    },
    addConfirm() {
      this.isModalActive = false;
      this.$buefy.snackbar.open({
        message: "Confirmed",
        queue: false
      });
    },
    addCancel() {
      this.isModalActive = false;
    },
    isAdmin() {
      if (
        this.userHasPermission(Permission.RTRACKER_REPORT_ASSIGN_ALL) ||
        this.userHasPermission(Permission.RTRACKER_REPORT_CHANGE_OWN)
      ) {
        return true;
      }
      return false;
    }
  }
};
</script>
